import * as React from 'react';
import type { TransportRoute } from 'contracts/transport-routes';
import { apiGeneral, handleApiError, queryBuilder } from 'services/api';

export const useFetchTransportRoute = () => {
  const fetchTransportRoute = React.useCallback(async (id: string | number) => {
    try {
      const { data } = await apiGeneral.get<TransportRoute>(`/general-route/${id}`);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchTransportRoute,
  };
};